import { createSelector } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux'

export const PERMISSION_LEVELS = {
  MANAGE: 'manage',
  READ_ONLY: 'readOnly',
  DISABLED: 'disabled',
}

const get = ({ userPermissions } = {}) => userPermissions?.data

// collection
export const getUserCollectionId = createSelector(get, (userPermissions) => userPermissions?.collectionId)

// customers
export const getUserAllowedCustomers = createSelector(get, (userPermissions) => userPermissions?.customers)

export const getHasAllCustomersAccess = createSelector(
  getUserAllowedCustomers,
  (userCustomers) => userCustomers?.length === 1 && userCustomers?.[0] === 0,
)

// permissions
export const getUserPermissions = createSelector(get, (userPermissions) => userPermissions?.permissions)

export const usePermission = (permissionName) => {
  const permissionsMap = useSelector(getUserPermissions)
  return permissionsMap?.[permissionName]
}

export const useIsAllowedToManage = (permissionName) => {
  const permission = usePermission(permissionName)
  return permission === PERMISSION_LEVELS.MANAGE
}
